<script setup lang="ts">
import { ExperimentValue } from '@core/types'
import type { HeaderProps } from '#layers/uk/types'

const props = defineProps<HeaderProps>()

const COMPONENTS: Partial<Record<string, ReturnType<typeof defineAsyncComponent>>> = {
    a: defineAsyncComponent(() => import('./A.vue')),
    b: defineAsyncComponent(() => import('./B.vue')),
}

const header = computed(() => COMPONENTS[props.type] ?? COMPONENTS[ExperimentValue.A])
</script>

<template>
    <component :is="header" v-bind="props" />
</template>
